import http from "./httpService";

const apiEndpoint = "communities";

export function getAllCommunities() {
  return http.get(apiEndpoint);
}
